import React from 'react';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { PanelV2 } from 'src/components/HTKit/Elements/PanelV2';
import Icon from 'src/components/HTKit/Icon';
import { Picture, TYPES } from 'src/components/Elements/Picture';
import image from 'src/images/products/prod-specialist.png';
import { specialistChatClickSegment } from 'src/containers/ProductPage/actions';
import { BUTTON_TEXT } from 'src/components/Product/ProductCtaBlock/constants';
import styles from './styles.scss';

const ProductSpecialistChat = ({ service, onSpecialistChatClick, className }) => {
  const imageSources = [
    {
      srcSet: image,
      type: TYPES.PNG,
    },
  ];
  const dispatchReduxAction = useDispatch();
  const onClick = () => {
    dispatchReduxAction(
      specialistChatClickSegment({ service, location: 'Have Questions Section' }),
    );
    onSpecialistChatClick();
  };
  return (
    <section onClick={onClick} className={className}>
      <PanelV2
        className={cn(
          'lowShadow mediumBorderRadius padding-small marginBottom-small',
          styles.chatButtonContainer,
        )}
      >
        <div className={styles.leftContent}>
          <Picture
            sources={imageSources}
            className={styles.productSpecialist}
            alt="product-specialist"
          />
          <div className="paddingLeft-small1">
            <h5>Have questions?</h5>
            <p className="p1 n900 paddingTop-tiny">{BUTTON_TEXT.PRODUCT_SPECIALIST_CHAT}.</p>
          </div>
        </div>
        <div className={styles.rightContent}>
          <Icon name="v2-skinny-arrow-right" />
        </div>
      </PanelV2>
    </section>
  );
};

ProductSpecialistChat.propTypes = {
  service: PropTypes.object,
  onSpecialistChatClick: PropTypes.func,
  className: PropTypes.string,
};

export default ProductSpecialistChat;
